export const articles = [
  {
    id: '1',
    title: '独家：某顶流男星深夜密会神秘女子，疑似新恋情曝光！',
    slug: 'top-star-secret-date-new-romance',
    excerpt: '据知情人士透露，该顶流男星近日频繁出入某高档小区，深夜密会长发神秘女子，两人举止亲密，疑似新恋情浮出水面。更多细节正在追踪中...',
    content: '<p>据知情人士透露，该顶流男星近日频繁出入某高档小区，深夜密会长发神秘女子，两人举止亲密，疑似新恋情浮出水面。</p><p>据目击者称，该男子身着黑色卫衣，头戴棒球帽，刻意压低帽檐，但依然被眼尖的粉丝认出。该女子身着白色连衣裙，身高约170cm，长发披肩，气质出众。</p><p>两人在小区门口短暂交谈后，一同进入楼内，直至次日清晨该男子才独自离开。期间未见该女子外出。</p><p>值得一提的是，该男星此前曾在公开场合多次表示自己"单身"，此次被拍或将成为其形象危机。其工作室目前尚未对此事作出回应。</p><p>更多独家细节，请持续关注51吃瓜官网的最新报道。</p>',
    category: '明星八卦',
    categorySlug: 'celebrity-gossip',
    coverImage: 'https://readdy.ai/api/search-image?query=Celebrity%20man%20in%20black%20hoodie%20and%20baseball%20cap%20walking%20with%20mysterious%20woman%20in%20white%20dress%20at%20night%20in%20luxury%20neighborhood%2C%20paparazzi%20style%20photography%2C%20dark%20moody%20atmosphere%2C%20cinematic%20lighting%2C%20dramatic%20shadows%2C%20urban%20night%20scene%2C%20blurred%20background%20with%20warm%20street%20lights&width=800&height=500&seq=article-cover-01&orientation=landscape',
    author: '吃瓜小编',
    publishDate: '2026-07-07',
    publishTime: '14:32',
    views: 128500,
    tags: ['顶流男星', '新恋情', '深夜密会', '独家爆料', '明星八卦'],
    isHot: true,
    isExclusive: true,
  },
  {
    id: '2',
    title: '重磅！某综艺节目录制现场突发意外，两位嘉宾当场翻脸离场',
    slug: 'variety-show-fight-live-incident',
    excerpt: '某热门综艺节目最新一期录制现场突发状况，两位重量级嘉宾因游戏环节产生争执，当场翻脸，导致录制被迫中断长达两小时。',
    content: '<p>据现场工作人员爆料，某热门综艺节目最新一期录制过程中突发意外状况。两位重量级嘉宾因游戏环节的规则争议产生激烈争执。</p><p>知情人士透露，争议起因于一位嘉宾认为另一位在游戏中"作弊"，双方言辞激烈，气氛一度十分紧张。其中一位嘉宾情绪激动，当场摘掉麦克风离场，另一位紧随其后。</p><p>节目组紧急协调，录制被迫中断长达两小时。最终在导演组和经纪团队的介入下，两位嘉宾才勉强返回完成后续录制，但全程零交流。</p><p>该节目一向以"欢乐和谐"著称，此次意外令节目组十分尴尬。目前尚不清楚播出时是否会保留这一片段。</p>',
    category: '综艺热点',
    categorySlug: 'variety-hot',
    coverImage: 'https://readdy.ai/api/search-image?query=TV%20variety%20show%20recording%20studio%20set%20with%20bright%20lights%20and%20cameras%2C%20two%20people%20arguing%20dramatically%20on%20stage%2C%20crew%20members%20looking%20shocked%20in%20background%2C%20tense%20atmosphere%2C%20television%20production%20setting%2C%20dramatic%20lighting%2C%20behind%20the%20scenes%20chaos&width=800&height=500&seq=article-cover-02&orientation=landscape',
    author: '前线记者',
    publishDate: '2026-07-07',
    publishTime: '11:15',
    views: 95600,
    tags: ['综艺节目', '嘉宾翻脸', '录制事故', '幕后爆料'],
    isHot: true,
    isExclusive: true,
  },
  {
    id: '3',
    title: '某知名导演新片选角内幕曝光：这个角色原本不是他的！',
    slug: 'director-casting-insider-secret',
    excerpt: '据圈内人士爆料，某知名导演筹备三年的新片在选角过程中暗藏玄机，男主角的最终人选经历了多轮博弈，背后资本力量不可小觑。',
    content: '<p>据圈内资深人士向51吃瓜官网独家透露，某知名导演筹备三年的新片在选角过程中暗藏玄机。</p><p>据悉，该片男主角最初定下的并非目前官宣的人选，而是另一位实力派演员。然而在投资方介入后，选角方向发生了180度转变。</p><p>"原定人选已经完成了定妆照拍摄和部分剧本围读，但最终还是被替换了，"知情人士表示，"背后涉及的投资方博弈非常复杂。"</p><p>目前该片已正式开机，片方对选角争议保持沉默。而原定主演的粉丝们仍对此事耿耿于怀，在社交平台上持续发声。</p>',
    category: '影视资讯',
    categorySlug: 'film-tv-news',
    coverImage: 'https://readdy.ai/api/search-image?query=Film%20director%20chair%20on%20movie%20set%20with%20script%20and%20clapperboard%2C%20cinematic%20lighting%2C%20behind%20the%20scenes%20film%20production%2C%20dramatic%20spotlight%20on%20empty%20director%20chair%2C%20mysterious%20atmosphere%2C%20professional%20film%20set%2C%20Hollywood%20style%20production&width=800&height=500&seq=article-cover-03&orientation=landscape',
    author: '影视侦探',
    publishDate: '2026-07-06',
    publishTime: '20:45',
    views: 78200,
    tags: ['导演', '选角内幕', '新片', '资本博弈', '影视圈'],
    isHot: true,
    isExclusive: true,
  },
  {
    id: '4',
    title: '某当红女星离婚真相曝光：前夫出轨证据确凿，财产分割内幕惊人',
    slug: 'actress-divorce-truth-exposed',
    excerpt: '持续发酵的某女星离婚案迎来重大进展，多方证据指向其前夫婚内出轨，而财产分割方案更是令网友直呼"太憋屈"。',
    content: '<p>持续数月占据热搜的某当红女星离婚案迎来重大进展。51吃瓜官网独家获取了多份关键证据，指向其前夫在婚姻存续期间存在严重不忠行为。</p><p>据接近当事人的消息源透露，该女星在发现前夫出轨后，曾多次尝试挽回婚姻，但对方态度强硬且毫无悔意。最终在掌握了确凿证据后，女星才下定决心离婚。</p><p>然而令人唏嘘的是，由于婚前协议的不平等条款，女星在财产分割中处于极为不利的位置。网友纷纷留言表示"心疼"、"渣男不得好报"。</p><p>目前该女星已全面复工，状态看起来不错，粉丝们也松了一口气。</p>',
    category: '明星八卦',
    categorySlug: 'celebrity-gossip',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20actress%20looking%20sad%20and%20thoughtful%20by%20window%20with%20rain%20outside%2C%20emotional%20portrait%20photography%2C%20soft%20natural%20light%2C%20melancholic%20mood%2C%20minimalist%20interior%2C%20warm%20but%20somber%20tones%2C%20cinematic%20feel&width=800&height=500&seq=article-cover-04&orientation=landscape',
    author: '吃瓜小编',
    publishDate: '2026-07-06',
    publishTime: '16:20',
    views: 156300,
    tags: ['女星', '离婚真相', '出轨', '财产分割', '明星八卦'],
    isHot: true,
    isExclusive: false,
  },
  {
    id: '5',
    title: '某千万粉丝网红直播间言论翻车，品牌方连夜宣布解约！',
    slug: 'influencer-live-stream-scandal',
    excerpt: '一场直播让某拥有千万粉丝的网红陷入巨大争议，因其在直播中的不当言论引发众怒，多个合作品牌火速切割，一夜之间损失惨重。',
    content: '<p>一场普通的带货直播，却让某拥有千万粉丝的头部网红陷入了职业生涯最大的危机。</p><p>据悉，该网红在直播中因与观众发生口角，情绪失控说出了极具争议的言论，被网友截屏疯传。短短几小时内，相关话题冲上热搜榜首。</p><p>更令其团队措手不及的是，三个主要合作品牌在当晚接连发布声明，宣布与该网红解除所有合作关系。据业内人士估算，此次事件给该网红带来的直接经济损失可能高达数千万元。</p><p>目前该网红已发布道歉视频，但网友并不买账，评论区仍然一片骂声。</p>',
    category: '网红动态',
    categorySlug: 'influencer-news',
    coverImage: 'https://readdy.ai/api/search-image?query=Influencer%20live%20streaming%20setup%20with%20ring%20light%20and%20microphone%2C%20dramatic%20red%20alert%20lighting%2C%20smartphone%20showing%20angry%20comments%2C%20tense%20streaming%20studio%20atmosphere%2C%20modern%20content%20creator%20room%2C%20digital%20drama%20scene%2C%20social%20media%20crisis&width=800&height=500&seq=article-cover-05&orientation=landscape',
    author: '前线记者',
    publishDate: '2026-07-05',
    publishTime: '22:10',
    views: 203400,
    tags: ['网红', '直播翻车', '品牌解约', '言论争议'],
    isHot: false,
    isExclusive: false,
  },
  {
    id: '6',
    title: '某影帝新片票房惨淡：投资3亿，首周票房仅800万',
    slug: 'box-office-flop-actor',
    excerpt: '曾被寄予厚望的某影帝新片上映首周票房惨遭滑铁卢，制作成本高达3亿元，首周票房却仅有800余万，投资方面临巨额亏损。',
    content: '<p>曾被寄予厚望的某影帝新片在上周末正式上映，然而票房表现却令人大跌眼镜。</p><p>据票房统计数据显示，该片制作成本高达3亿元人民币，加上宣发费用总投入接近4亿。但首周末三天票房仅收获800余万元，排片率也在持续下滑。</p><p>业内人士分析认为，该片票房失利的主要原因有三：一是题材过于小众，难以引起大众共鸣；二是同期有多部进口大片夹击，竞争激烈；三是前期宣传策略失误，未能有效触达目标受众。</p><p>按照目前的走势，该片最终票房可能难以突破3000万，投资方将面临巨额亏损。这也引发了业内对"流量+IP"模式是否已走到尽头的讨论。</p>',
    category: '影视资讯',
    categorySlug: 'film-tv-news',
    coverImage: 'https://readdy.ai/api/search-image?query=Empty%20movie%20theater%20with%20red%20seats%20and%20dim%20lighting%2C%20movie%20poster%20on%20wall%2C%20lonely%20atmosphere%2C%20cinema%20interior%2C%20dramatic%20shadows%2C%20melancholic%20vibe%2C%20commercial%20failure%20concept%2C%20wide%20angle%20shot&width=800&height=500&seq=article-cover-06&orientation=landscape',
    author: '影视侦探',
    publishDate: '2026-07-05',
    publishTime: '09:30',
    views: 89700,
    tags: ['影帝', '票房惨淡', '电影', '投资亏损'],
    isHot: false,
    isExclusive: false,
  },
  {
    id: '7',
    title: '某选秀节目被曝暗箱操作：淘汰名单提前泄露，节目组紧急发声明',
    slug: 'talent-show-rigging-exposed',
    excerpt: '热门选秀节目被曝存在严重暗箱操作，一份疑似内部淘汰名单在网络上疯传，与最终播出的结果高度吻合，引发观众强烈不满。',
    content: '<p>热门选秀节目《星光之路》最新一季被曝存在严重暗箱操作问题。</p><p>事件起因是一份疑似节目组内部的"淘汰顺序表"在网络上流出，详细标注了每位选手的淘汰轮次和最终排名。令人震惊的是，截至目前已播出的三期节目中，淘汰结果与这份名单完全吻合。</p><p>此事在粉丝群体中引发轩然大波，多位选手的粉丝组织联名抗议，要求节目组给出合理解释。相关话题阅读量在24小时内突破5亿。</p><p>节目组于昨日下午发布紧急声明，称该名单系"恶意伪造"，并表示已报警处理。但这一回应并未平息质疑，舆论仍在持续发酵。</p>',
    category: '综艺热点',
    categorySlug: 'variety-hot',
    coverImage: 'https://readdy.ai/api/search-image?query=Talent%20show%20stage%20with%20spotlights%20and%20microphone%20stand%2C%20dramatic%20red%20and%20gold%20lighting%2C%20empty%20stage%20with%20confetti%20on%20floor%2C%20backstage%20papers%20scattered%2C%20reality%20TV%20show%20set%2C%20controversy%20atmosphere%2C%20behind%20the%20scenes%20drama&width=800&height=500&seq=article-cover-07&orientation=landscape',
    author: '吃瓜小编',
    publishDate: '2026-07-04',
    publishTime: '18:55',
    views: 178200,
    tags: ['选秀节目', '暗箱操作', '淘汰名单', '综艺', '争议'],
    isHot: true,
    isExclusive: true,
  },
  {
    id: '8',
    title: '某知名主持人被爆税务问题，工作室凌晨发声明否认',
    slug: 'host-tax-investigation-rumor',
    excerpt: '一则关于某知名主持人涉嫌税务违规的消息在网络上迅速传播，引发各方关注。其工作室凌晨紧急发布声明，称相关消息"严重失实"。',
    content: '<p>今日凌晨，一则关于某知名主持人涉嫌重大税务违规的消息在社交平台上迅速传播，引发全网关注。</p><p>该消息称，该主持人在过去三年间通过多种方式逃避个人所得税，涉及金额可能高达数千万元。消息还称相关部门已介入调查。</p><p>凌晨3时许，该主持人的工作室紧急发布声明，称上述消息"纯属捏造，严重失实"，并表示将追究造谣者的法律责任。声明强调该主持人一向遵纪守法，依法纳税。</p><p>但值得注意的是，声明中并未直接否认"相关部门调查"的说法，这也让部分网友对事件真相持保留态度。</p>',
    category: '明星八卦',
    categorySlug: 'celebrity-gossip',
    coverImage: 'https://readdy.ai/api/search-image?query=TV%20host%20studio%20with%20professional%20lighting%20setup%2C%20empty%20news%20desk%20with%20microphone%2C%20dramatic%20shadows%20and%20spotlight%2C%20serious%20atmosphere%2C%20broadcast%20studio%20interior%2C%20professional%20newsroom%20setting%2C%20tense%20mood&width=800&height=500&seq=article-cover-08&orientation=landscape',
    author: '前线记者',
    publishDate: '2026-07-04',
    publishTime: '08:10',
    views: 134600,
    tags: ['主持人', '税务问题', '声明', '辟谣'],
    isHot: false,
    isExclusive: false,
  },
  {
    id: '9',
    title: '某顶流女团成员被拍到与神秘男子同游日本，粉丝心碎一地',
    slug: 'girl-group-member-japan-trip',
    excerpt: '有网友在日本东京偶遇某顶流女团成员与一名神秘男子亲密同游，两人有说有笑，疑似关系不一般。粉丝群体反应激烈。',
    content: '<p>今日下午，有网友在日本东京银座偶遇某顶流女团成员，更令人惊讶的是，她身边还有一位神秘男子同行。</p><p>据目击网友描述，两人在奢侈品店内逗留许久，该男子全程陪同并多次为女团成员拎包。离开店铺后，两人还一同前往附近的日料餐厅用餐，期间互动亲密，有说有笑。</p><p>照片在粉丝社群中迅速传播，引发了激烈讨论。部分粉丝表示"祝福"，但更多粉丝表达了心碎和不满的情绪。该女团正处于上升期，恋爱传闻可能对其事业造成影响。</p><p>截至目前，该女团所属经纪公司尚未对此事作出回应。</p>',
    category: '明星八卦',
    categorySlug: 'celebrity-gossip',
    coverImage: 'https://readdy.ai/api/search-image?query=Tokyo%20Ginza%20luxury%20shopping%20street%20at%20dusk%2C%20fashionable%20young%20Asian%20couple%20walking%20with%20shopping%20bags%2C%20blurred%20background%20with%20neon%20signs%2C%20paparazzi%20style%20candid%20shot%2C%20warm%20evening%20light%2C%20urban%20Japanese%20cityscape%2C%20romantic%20atmosphere&width=800&height=500&seq=article-cover-09&orientation=landscape',
    author: '吃瓜小编',
    publishDate: '2026-07-03',
    publishTime: '16:40',
    views: 189500,
    tags: ['女团', '日本', '恋爱', '偶遇', '粉丝'],
    isHot: true,
    isExclusive: false,
  },
  {
    id: '10',
    title: '某老牌歌手宣布暂别歌坛：身体原因，归期未定',
    slug: 'veteran-singer-hiatus-health',
    excerpt: '纵横歌坛二十余年的某老牌实力歌手今日通过社交媒体宣布，因身体健康原因将暂别歌坛，原定巡演全部取消，歌迷纷纷表示理解与不舍。',
    content: '<p>今天上午，纵横歌坛二十余年的某老牌实力歌手通过个人社交媒体发布长文，宣布因身体健康原因将暂别歌坛。</p><p>在这篇情真意切的告别声明中，该歌手回顾了自己二十多年的音乐生涯，感谢了歌迷多年来的支持与陪伴。对于暂别的原因，他表示近一年来身体状况持续不佳，医生强烈建议他停下工作好好休养。</p><p>受此影响，原定于今年下半年在全国十座城市举办的巡回演唱会已全部取消，退票工作将从下周开始。</p><p>消息一出，无数歌迷涌入其社交账号留言，既有不舍之情，也充满了对他健康的美好祝愿。</p>',
    category: '明星八卦',
    categorySlug: 'celebrity-gossip',
    coverImage: 'https://readdy.ai/api/search-image?query=Empty%20concert%20stage%20with%20microphone%20stand%20and%20guitar%2C%20soft%20spotlight%2C%20melancholic%20atmosphere%2C%20music%20venue%2C%20farewell%20concert%20vibe%2C%20warm%20golden%20lighting%2C%20emotional%20goodbye%20scene%2C%20professional%20stage%20setup&width=800&height=500&seq=article-cover-10&orientation=landscape',
    author: '影视侦探',
    publishDate: '2026-07-03',
    publishTime: '10:25',
    views: 98700,
    tags: ['歌手', '暂别歌坛', '健康', '巡演取消'],
    isHot: false,
    isExclusive: false,
  },
  {
    id: '11',
    title: '某热播剧编剧被指抄袭：网友整理对比图，相似度惊人',
    slug: 'screenwriter-plagiarism-accusation',
    excerpt: '近期大热的某古装剧陷入抄袭风波，有网友整理了该剧与多部海外剧集的对比截图，多个关键情节高度相似，引发热议。',
    content: '<p>近期正在热播的某古装剧，凭借精良的制作和演员的出色表演收获了不俗口碑。然而，一场抄袭风波正在悄然发酵。</p><p>有热心网友整理了该剧与三部海外热门剧集的详细对比，发现至少有六处关键情节设计、人物关系和台词存在高度相似。对比截图在网络上迅速传播，相似度之惊人令不少观众大跌眼镜。</p><p>该剧编剧团队目前尚未对此作出回应。但出品方的一位工作人员私下透露，公司已注意到相关讨论，正在进行内部核查。</p><p>抄袭指控在影视圈向来敏感，若属实将对编剧团队和剧集口碑造成严重打击。</p>',
    category: '影视资讯',
    categorySlug: 'film-tv-news',
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20costume%20drama%20film%20set%20with%20traditional%20robes%20and%20props%2C%20dramatic%20lighting%2C%20script%20pages%20scattered%20on%20wooden%20table%2C%20controversy%20theme%2C%20period%20drama%20production%2C%20historical%20Chinese%20setting%2C%20mysterious%20atmosphere&width=800&height=500&seq=article-cover-11&orientation=landscape',
    author: '影视侦探',
    publishDate: '2026-07-02',
    publishTime: '21:15',
    views: 114300,
    tags: ['热播剧', '编剧', '抄袭', '古装剧', '争议'],
    isHot: false,
    isExclusive: false,
  },
  {
    id: '12',
    title: '独家：某知名经纪人跳槽带走多位艺人，原公司陷入生存危机',
    slug: 'manager-poaching-artists-crisis',
    excerpt: '娱乐圈大地震！某顶级经纪人突然从原公司离职，并带走旗下多位一线艺人，原公司艺人资源几乎被掏空，股价应声大跌。',
    content: '<p>51吃瓜官网独家获悉，娱乐圈正经历一场前所未有的人事地震。某在业内享有盛誉的顶级经纪人已于上周正式从原经纪公司离职。</p><p>更令原公司措手不及的是，该经纪人离职后迅速带着旗下多位一线艺人转投竞争对手。据不完全统计，至少有五位知名艺人跟随其一同离开，原公司核心艺人资源几乎被掏空。</p><p>受此消息影响，原公司股价在本周一大跌12%，市值蒸发数十亿。公司高层正紧急召开董事会商讨应对策略。</p><p>业内分析人士认为，此次事件的背后反映出传统经纪模式正面临巨大挑战，艺人对于经纪公司的依赖程度在持续降低。</p>',
    category: '独家爆料',
    categorySlug: 'exclusive-scoop',
    coverImage: 'https://readdy.ai/api/search-image?query=Empty%20luxury%20office%20with%20glass%20walls%20and%20modern%20furniture%2C%20dramatic%20lighting%2C%20business%20documents%20on%20desk%2C%20corporate%20crisis%20atmosphere%2C%20high%20rise%20building%20view%20through%20window%2C%20dusk%20cityscape%2C%20tension%20and%20uncertainty%20mood&width=800&height=500&seq=article-cover-12&orientation=landscape',
    author: '吃瓜小编',
    publishDate: '2026-07-02',
    publishTime: '12:00',
    views: 167800,
    tags: ['经纪人', '跳槽', '艺人', '娱乐圈', '独家'],
    isHot: true,
    isExclusive: true,
  },
];

export const categories = [
  { slug: 'celebrity-gossip', name: '明星八卦', description: '最新最全的明星八卦资讯，涵盖恋情、婚姻、家庭等各个方面' },
  { slug: 'exclusive-scoop', name: '独家爆料', description: '51吃瓜官网独家爆料，全网首发，让你走在吃瓜第一线' },
  { slug: 'variety-hot', name: '综艺热点', description: '热门综艺节目幕后花絮、录制内幕、嘉宾动态一网打尽' },
  { slug: 'film-tv-news', name: '影视资讯', description: '电影电视剧最新资讯、票房数据、选角内幕、片场趣闻' },
  { slug: 'influencer-news', name: '网红动态', description: '网红圈最新动态、直播翻车、带货战绩、粉丝互动全记录' },
];